import React from "react";
import { motion } from "framer-motion";
import Reveal from "../../Reveal";
import { useI18n } from "../../../i18n/LanguageContext";
import { SITE } from "../../../content/site";

export default function MediaEngine() {
  const { lang } = useI18n();
  const c = (SITE[lang].homeStory || SITE.en.homeStory).media;
  const alt = (SITE[lang].events || SITE.en.events).alt;

  return (
    <section data-testid="home-media" className="bg-[#0a0a0b] px-6 py-28 md:px-12 md:py-40">
      <div className="mx-auto max-w-[1400px]">
        <Reveal><p className="overline text-white/40">{c.overline}</p></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display mt-7 max-w-3xl text-3xl font-light leading-[1.05] tracking-tightest text-white md:text-5xl">{c.title}</h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base font-light leading-relaxed text-white/65 md:text-lg">{c.text}</p>
        </Reveal>

        <div className="mt-16 grid gap-12 md:mt-20 lg:grid-cols-12 lg:gap-8">
          {/* Input: the event */}
          <div className="lg:col-span-5">
            <Reveal>
              <div data-testid="media-input" className="lg:sticky lg:top-28">
                <div className="overflow-hidden rounded-2xl border border-white/15">
                  <img src="/events/usa.jpg" alt={alt.usa} loading="lazy" width="1920" height="1280"
                    className="aspect-[16/10] w-full object-cover" />
                  <div className="flex items-center justify-between gap-4 border-t border-white/10 bg-white/[0.03] px-6 py-5">
                    <div>
                      <p className="font-display text-xl font-light text-white md:text-2xl">{c.input}</p>
                      <p className="mt-1 text-sm font-light text-white/45">{c.inputSub}</p>
                    </div>
                    <span className="flex h-2.5 w-2.5 rounded-full bg-[#2aa08c]" />
                  </div>
                </div>
              </div>
            </Reveal>
          </div>

          {/* Outputs fan out */}
          <div className="lg:col-span-7">
            <div className="space-y-0">
              {c.outputs.map((o, i) => (
                <Reveal key={o.k} delay={0.1 * i}>
                  <div data-testid={`media-output-${i}`} className="group flex items-start gap-6 border-b border-white/10 py-7 md:gap-8">
                    <motion.span
                      initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true, margin: "-60px" }}
                      transition={{ duration: 0.8, delay: 0.15 + i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                      className="mt-4 hidden h-px w-12 origin-left bg-[#2aa08c] md:block"
                    />
                    <div className="flex-1">
                      <h3 className="font-display text-xl font-light tracking-tight text-white transition-colors group-hover:text-[#2aa08c] md:text-2xl">{o.k}</h3>
                      <p className="mt-2 max-w-xl text-sm font-light leading-relaxed text-white/50 md:text-base">{o.d}</p>
                    </div>
                    <span className="font-display mt-1 text-xs tracking-[0.25em] text-white/25">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
